import React from 'react';
import {createRoot} from 'react-dom/client';
import styles from './styles.module.css';

const sections = document.getElementsByTagName('h2');

const Contents = () => {
    const [top, setTop] = React.useState<number>();
    const [selected, setSelected] = React.useState(0);
    const sectionElements: (HTMLElement | null)[] = [];
    for (let i = 0; i < sections.length; i++) {
        sectionElements.push(sections.item(i));
    }

    React.useEffect(() => {
        const findPos = () => {
            const {scrollY} = window;
            const offset = 128;
            const threshold = window.innerWidth / 4 + offset;
            if (scrollY > threshold - offset) {
                setTop(offset);
            } else {
                const distance = threshold - scrollY;
                setTop(distance);
            }

            const lastNegativeElement = sectionElements.reduce(
                (acc, cur, ind) => {
                    if (cur) {
                        const {top} = cur.getBoundingClientRect();
                        if (top < 129) {
                            return ind;
                        }
                        return acc;
                    }
                    return acc;
                },
                0,
            );
            setSelected(lastNegativeElement);
        };

        document.addEventListener('scroll', findPos);
        document.addEventListener('resize', findPos);
        findPos();

        return () => {
            document.removeEventListener('scroll', findPos);
            document.removeEventListener('resize', findPos);
        };
    }, []);

    if (typeof top === 'undefined' || sectionElements.length === 0) {
        return null;
    }

    return (
        <div className={styles.container} style={{top}}>
            <b>Contents</b>
            <div className={styles.inner}>
                {sectionElements.map((section, ind) => (
                    <a
                        href={`#${section?.getAttribute('id')}`}
                        key={section?.getAttribute('id')}
                        className={selected === ind ? styles.selected : ''}
                    >
                        {section?.textContent}
                    </a>
                ))}
            </div>
        </div>
    );
};

export default () => {
    const domNode = document.getElementById('contents');
    if (domNode) {
        const root = createRoot(domNode);
        root.render(<Contents />);
    }
};
